import R, { test, either } from 'ramda';
import {
  standardNonAccomDescrs,
  multiDayTourDescrs,
} from './contracting-preset-names-codes';

export default (desc, isMultiDayTour) => {
  if (desc.indexOf('Up to') > -1) return true;
  const validGuestCountForNewContract = test(/^[0-9]+ Guests$/gm);

  const acceptedNewDescriptions = !isMultiDayTour ? [
    ...standardNonAccomDescrs,
    'Single',
    'Double',
    'Twin',
    'Triple',
    'Quad',
    '1 Guest',
    'Up to',
    'Extra Adult',
    'Extra Child',
    'Extra Infant',
    'Per Person',
  ] : multiDayTourDescrs;

  const descriptionInValidDescriptions = str => R.contains(str, acceptedNewDescriptions);
  return R.call(either(descriptionInValidDescriptions, validGuestCountForNewContract), desc);
};



// WEBPACK FOOTER //
// ./src/app/utils/checkRatesDescriptionHelper.js